import { DataBean } from "../../DataBean";


export class SideType extends DataBean {

    public async getPersonPhotoTypes(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPersonPhotoTypes_Number", [args]);
    }

}